module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jpoQY"))).then(() => module.bundle.root('1iHdE'));